import React from 'react';
import { translate } from 'react-i18next';
import { Segment, Container, Card, Image, Label, Icon, Button } from 'semantic-ui-react';

import TimeRemainingLabel from 'modules/misc/TimeRemainingLabel.js';
import ChallengeUtils from 'utils/ChallengeUtils.js';
import Utils from 'utils/Utils.js';
import {colors, spacings} from 'style';

const style = {
    card: {
        width: '400px',
        height: '70px',
        marginTop: spacings.small,
        marginBottom: spacings.small,
        marginLeft: '0',
        marginRight: '0',
        backgroundColor: colors.themeBlue,
        color: '#fff',
    },
    cropper: {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        borderRadius: 'inherit',
        border: 'none',
    },
    content: {
        paddingTop: '5px',
        paddingBottom: '5px',
    },
    titleBar: {
        height: '50px',
        width: '100%',
        backgroundColor: colors.themeOrange,
        textAlign: 'center',
    },
    title: {
        fontSize: '1.2em',
        lineHeight: '20px',
    },
    subtitle: {
        fontSize: '0.8em',
        lineHeight: '10px',
    },
    image:{
        height: '250px',
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
        backgroundRepeat: 'no-repeat',
    },
    cardHeader: {
        color: '#fff',
        textAlign: 'center',
        fontSize: '0.95em',
    },
    meta: {
        paddingTop: '5px',
    },
    metaItem: {
        textAlign: 'center',
        fontWeight: 'light',
        fontSize: '0.9em',
        lineHeight: '1.2em',
    },
    pointsIcon: {
        color: colors.pointsYellow,
    },
    leaderboardIcon: {
        position: 'absolute',
        right: '5px',
        top: '12px',
        color: '#fff',
        width: '50px',
        height: '50px',
        lineHeight: '25px',
        fontSize: '25px',
    },
    timeRemaining: {
        position: 'absolute',
        top: '-20px',
        left: '50%',
        marginLeft: '-125px',
        zIndex: '10',
    }
};

const TeamChallengeCard = ({t,
                            leaderboard,
                            onClickLeaderboard,
                            centered}) => (
    <Card key={leaderboard.id} style={style.card} onClick={()=>onClickLeaderboard(leaderboard)} centered={centered}>
        <div>{/*This affects style*/}</div>
        {(leaderboard.season && leaderboard.season.endsAt) &&
            <TimeRemainingLabel style={style.timeRemaining} endsAt={leaderboard.season.endsAt} />
        }
        <div style={style.cropper}>
            <div style={{...style.titleBar, ...((leaderboard.season && leaderboard.season.endsAt) ? {paddingTop: '20px', height: '70px'} : {} )}}>
                <div style={{...style.title, ...(leaderboard.invitations>0)?{lineHeight:'20px', paddingTop:'5px'}:{lineHeight:'50px'}}}>
                    {t('Team Challenge')}
                </div>
                {(leaderboard.invitations>0) &&
                    <div style={style.subTitle}>
                        {t('Pending Invitations')}
                    </div>
                }
                <Icon style={{...style.leaderboardIcon, ...((leaderboard.season && leaderboard.season.endsAt) ? {top: '32px'} : {} )}} className={leaderboard.invitations>0 ? 'icon-mail' : 'icon-leaderboard'}/>
            </div>
        </div>
        <div>{/*This affects style*/}</div>
    </Card>
);

export default translate('challenges')(TeamChallengeCard);



// WEBPACK FOOTER //
// ./src/modules/cards/TeamChallengeCard.js